import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { ITsdDocument } from '~/types/document/models'

export const {
  getDocumentListData: getTsdDocumentListData,
  getDocumentDataById: getTsdDocumentDataById,
  getDocumentListDataByParentId: getTsdDocumentListDataByTsdId,
} = makeDocumentMockData<ITsdDocument>({
  entityName: 'tsd',
  storageKeyPrefix: 'tsd',
})
